import styled from 'styled-components';
import backgroundImage from '../../static/images/login/background.png';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 840px;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent
    linear-gradient(
      180deg,
      ${({ theme }) => theme.pink} 0%,
      ${({ theme }) => theme.purple} 100%
    )
    0% 0% no-repeat padding-box;
`;

export const Background = styled.div`
  width: 100%;
  height: 100vh;
  min-height: 840px;
  position: absolute;
  top: 0px;
  left: -354px;
  background: transparent url(${backgroundImage}) 0% 0% no-repeat padding-box;
`;

export const Content = styled.div`
  width: 700px;
  height: 100vh;
  min-height: 840px;
  background: ${({ theme }) => theme.neutral_300} 0% 0% no-repeat padding-box;
  color: ${({ theme }) => theme.neutral_500};
  padding: 85px 158px 76px 158px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  right: 10%;
  box-shadow: -28px 12px 40px #33333361;
  opacity: 1;

  @media only screen and (max-width: 1000px) {
    width: 100%;
    height: auto;
    padding: 28px 18px;
    right: 0;
  }

  @media only screen and (min-height: 768px) and (max-height: 1280px) {
    height: 100%;
  }

  img {
    @media only screen and (max-width: 480px) {
      width: 65%;
    }
  }

  form {
    width: 100%;
    display: flex;
    flex-direction: column;

    button {
      width: 100%;
      height: 69px;
      text-transform: uppercase;
      border-radius: 18px;
      margin-top: 56px;
      margin-bottom: 60px;

      @media only screen and (max-width: 480px) {
        height: 54px;
      }
    }
  }
`;
